import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import ButtonScogoPrimary from '../../../../common/Buttons/ButtonScogoPrimary';
import { useDispatch } from 'react-redux';
import { closeModalAction, openCustomModal } from '../../../../actions/modal';
import { transferFromWalletToBank, withdrawFromWallet } from '../../../../actions/wallet';
import { isCluster, isFe, isIsp, isPsp, isScm, isSp, isSpIsp, isSuperVisor } from '../../../../utils/role';
import { getUserDetailsByID, postBankDetails } from '../../../../actions/users';
import { WITHDRAW_FROM_WALLET_OTP_SUCCESS } from '../../../../types/wallet';
import { SkeltonCardOne } from '../../../../common/SkeltonCardOne';
import { motion } from 'framer-motion';
import { convertIntoPaisa, convertIntoRupee, PaymentProvider } from '../../../../utils/utils';
import { convertToLakhOrCrore, isBoltOrg, ScogoID } from '../../../../utils/common';
import { RenderBankDetails, ScogoAmountBalance } from '../../../Wallet/Modals/SendToBank';
import Input from '../../../../common/Form/Input';
import Form from '../../../../common/Form';
import { useForm } from 'react-hook-form';
import development from '../../../../config/env/development';
import config from '../../../../config';
import RenderMilestones from '../../../Ticket/components/RenderMileStones';
import { getAmount } from '../../../Wallet/components/Passbook/Card';
import { TransactionStatus } from '../../PaymentController';
import { TransactionCategory, TransactionPurpose, TransactionTransferType } from '../../../Wallet/walletController';
import { MilestoneSubStatus, TicketAgentRole } from '../../../Ticket/TicketController';


export default function TicketBankTransferPayment({ serviceRequest, selectedMilestone, rowPaymentsData }) {
    const dispatch = useDispatch();

    const onBankTransferClick = (e) => {
        dispatch(
            openCustomModal({
                heading: 'Direct Bank/UPI Transfer',
                modalWidth: '50vw',
                modalHeight: 'auto',
                modalComponent: <UsersList serviceRequest={serviceRequest} selectedMilestone={selectedMilestone} rowPaymentsData={rowPaymentsData} />
            })
        );
    }

    // if (rowPaymentsData.length === 0) return null;

    return <div className=''>
        <ButtonScogoPrimary
            textOrComponent={'Direct Bank/UPI Transfer'}
            onClick={(e) => onBankTransferClick(e)}
            loading={false}
            disabled={false}
            buttonIconComponent={<span className='material-icons text-xl'>account_balance</span>}
        />
    </div>
}
const UsersList = ({ rowPaymentsData, serviceRequest, selectedMilestone }) => {
    const [selectedUser, setSelectedUser] = useState(null);

    useEffect(() => {
        if (rowPaymentsData.length > 0) {
            setSelectedUser(`${rowPaymentsData[0].agent.id}-${rowPaymentsData[0].role}`);
        }
    }, [rowPaymentsData])

    const selectedUserData = useMemo(() => {
        if (selectedUser && rowPaymentsData.length > 0) {
            return rowPaymentsData.find((elem) => `${elem.agent.id}-${elem.role}` === selectedUser) || null;
        }
        return null;
    }, [rowPaymentsData, selectedUser]);

    const ticket_agent_role = useMemo(() => selectedUserData?.role || '', [selectedUserData]);

    const selectedUserId = useMemo(() => {
        if (selectedUser) {
            return selectedUser.split('-')[0];
        }
        return null;
    }, [selectedUser]);

    return (
        <div className="mt-2 flex flex-col max-h-[65vh]">
            <div className="flex flex-wrap gap-2 mb-4 px-6 shrink-0">
                {rowPaymentsData.map((user) => {
                    const userRoleKey = `${user.agent.id}-${user.role}`;
                    return (
                        <div
                            key={userRoleKey}
                            className={`px-4 py-2 rounded-full cursor-pointer transition-colors ${selectedUser === userRoleKey
                                ? 'bg-blue-100 border border-blue-300 text-blue-700'
                                : 'bg-gray-100 border border-gray-200 hover:bg-gray-200'
                                }`}
                            onClick={() => setSelectedUser(userRoleKey)}
                        >
                            <div className="flex items-center gap-2">
                                <span className="material-icons text-sm">
                                    {user.role === 'Cluster' ? 'hub' : 'person'}
                                </span>
                                <span className="font-medium text-sm">{user.role} : {user.agent.display_name}</span>
                                {selectedUser === userRoleKey && (
                                    <span className="material-icons text-blue-500 text-sm">check_circle</span>
                                )}
                            </div>
                        </div>
                    );
                })}
                {rowPaymentsData.length === 0 && (
                    <div className="p-4 text-center text-gray-500 w-full">No users available</div>
                )}
            </div>
            {selectedUser && <TicketDirectBankTransfer
                user_id={selectedUserId}
                ticket_agent_role={ticket_agent_role}
                serviceRequest={serviceRequest}
                selectedMilestone={selectedMilestone}
                selectedUserData={selectedUserData}
            />}
        </div>
    );
};


export const TicketDirectBankTransfer = ({ user_id, serviceRequest, ticket_agent_role, selectedUserData }) => {
    const formName = 'directBankTransfer';
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const defaultValues = { amount: '', otp: '', bank: '', acc_num: '', acc_type: 'SAVINGS', upi_vpa: '', ifsc: '', holder_name: '' };
    const myWalletDetail = useSelector((state) => state.wallet.myWalletDetail);
    const [amountError, setAmountError] = useState('');
    const isShowDailyLimit = false;
    const userDetailsById = useSelector((state) => state.user.userDetailsById);
    const isUserDetailsByIdLoading = useSelector((state) => state.loading.isUserDetailsByIdLoading);
    const [showAddBankForm, setShowAddBankForm] = useState(false);
    const [addFormType, setAddFormType] = useState('bank'); // 'bank' | 'upi'
    const [paymentMethod, setPaymentMethod] = useState('account_number');
    const methods = useForm({ defaultValues, mode: 'all' });
    const [selectedMilestones, setSelectedMilestones] = useState();
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);

    const isScogoAdmin = newLoggedUserData.org.id === ScogoID;

    const memoizedUserBankDetails = useMemo(() => {
        let data = {};
        if (userDetailsById[user_id]) {
            data = userDetailsById[user_id]?.user?.bank ? userDetailsById[user_id]?.user?.bank : {};
        }
        return data;
    }, [userDetailsById, user_id]);

    const memoizedUserTotalWithdrawl = useMemo(() => {
        let amount = 0;
        if (!isNaN(userDetailsById[user_id]?.user?.wallet?.total_withdrawn)) {
            amount = convertIntoRupee(userDetailsById[user_id]?.user?.wallet?.total_withdrawn);
        }
        return amount;
    }, [userDetailsById, user_id]);

    const hasBankDetails = useMemo(() => {
        return memoizedUserBankDetails && Object.keys(memoizedUserBankDetails).length > 0;
    }, [memoizedUserBankDetails]);

    const hasAccountNumber = useMemo(() => {
        return Boolean(memoizedUserBankDetails?.ifsc_code && memoizedUserBankDetails?.bank_name);
    }, [memoizedUserBankDetails]);

    const hasUpiId = useMemo(() => {
        return Boolean(memoizedUserBankDetails?.upi_id);
    }, [memoizedUserBankDetails]);

    useEffect(() => {
        if (user_id && !userDetailsById[user_id]) {
            dispatch(getUserDetailsByID({ user_id: user_id, give_total_withdraw: true }));
        }
    }, [user_id, dispatch, userDetailsById]);

    useEffect(() => {
        return () => dispatch({ type: WITHDRAW_FROM_WALLET_OTP_SUCCESS, payload: false });
    }, [dispatch]);


    useEffect(() => {
        if (development.name === config.name) {
            // methods.setValue('bank', 'HDFC Bank');
            // methods.setValue('acc_num', '1121431121541121');
            // methods.setValue('ifsc', 'HDFC0001234');
            // methods.setValue('holder_name', 'John Doe');
            // methods.setValue('upi_vpa', 'test@upi');
        }
        if (hasBankDetails || hasAccountNumber || hasUpiId) {
            setShowAddBankForm(false);
        }
    }, [hasBankDetails, hasAccountNumber, hasUpiId, methods]);

    // For Bolt org users, default the Account Holder Name to the user's display name
    useEffect(() => {
        if (newLoggedUserData?.org?.id === isBoltOrg && userDetailsById[user_id]?.user?.full_name) {
            methods.setValue('holder_name', userDetailsById[user_id].user.full_name);
        }
    }, [newLoggedUserData?.org?.id, userDetailsById, user_id, methods]);

    // For Bolt org users, the Account Holder Name must match the user's display name
    const validateHolderName = (value) => {
        const requiredName = userDetailsById[user_id]?.user?.full_name;
        if (newLoggedUserData?.org?.id === isBoltOrg && requiredName && value !== requiredName) {
            return `Account Holder Name must be ${requiredName}`;
        }
        return true;
    };

    // Default the payment method to whichever option the user actually has
    useEffect(() => {
        if (hasAccountNumber) {
            setPaymentMethod('account_number');
        } else if (hasUpiId) {
            setPaymentMethod('upi');
        }
    }, [hasAccountNumber, hasUpiId]);

    const handleFormSubmit = (formValues) => {
        if (showAddBankForm) {
            const bankDetails = {
                ...(formValues.bank ? { bank: formValues.bank } : {}),
                ...(formValues.acc_num ? { acc_num: formValues.acc_num } : {}),
                ...(formValues.ifsc ? { ifsc: formValues.ifsc } : {}),
                ...(formValues.holder_name ? { holder_name: formValues.holder_name } : {}),
                ...(formValues.upi_vpa ? { upi_vpa: formValues.upi_vpa } : {})
            }
            dispatch(postBankDetails({
                userId: user_id,
                bank_details: bankDetails,
                callUserDetails: true,
                closeModal: false,
                formName
            }));
            return;
        };

        const amount = parseInt(formValues.amount);

        if (amount <= 0) {
            setAmountError('Amount must be greater than 0');
            return;
        }

        if (amount > myWalletDetail?.balance) {
            setAmountError('Amount exceeds available balance');
            return;
        }

        if (isShowDailyLimit && myWalletDetail?.withdraw_limit && amount > myWalletDetail.withdraw_limit) {
            setAmountError(`Amount exceeds daily withdrawal limit of ₹${myWalletDetail.withdraw_limit}`);
            return;
        }
        setAmountError('');

        if (isScogoAdmin) {
            const payload = {
                beneficiary: user_id,
                amount: convertIntoPaisa(amount),
                currency: "INR",
                withdraw_to: paymentMethod,
                provider: PaymentProvider.BULKPE, // If Logged In User Is Scogo User Then Send Provider BULKPE
                remarks: formValues.remarks,
                ticket_id: serviceRequest.id,
                milestone_id: selectedMilestones,
                ticket_agent_role
            };
            dispatch(withdrawFromWallet({
                data: payload,
                formName,
                cleanUp: true,
                callUserWalletDetails: true
            }));
            return;
        };

        const payload = {
            org_id: serviceRequest.org_id,
            beneficiary: user_id,
            amount: convertIntoPaisa(amount),
            currency: "INR",
            withdraw_to: paymentMethod,
            remarks: formValues.remarks,
            provider: PaymentProvider.RAZORPAY,
            ticket_id: serviceRequest?.id || "",
            milestone_id: selectedMilestones,
            ticket_agent_role
        };
        let roles = serviceRequest.agents.filter(agent => agent.agent.id === newLoggedUserData.user.id).map(agent => agent.role);
        dispatch(transferFromWalletToBank({
            data: payload,
            formName,
            refreshPayments: true,
            ticketId: serviceRequest?.id,
            roles,
            org_id: serviceRequest.helpdesk_id
        }));
    };

    const { watch } = methods;
    const currentAmount = watch('amount');
    const currentBank = watch('bank');
    const currentAccNum = watch('acc_num');
    const currentIfsc = watch('ifsc');
    const currentHolderName = watch('holder_name');
    const serviceRequestPayments = useSelector((state) => state.serviceRequest.serviceRequestPayments);

    const userTicketBalance = useMemo(() => {
        let amount = 0;
        if (ticket_agent_role && serviceRequest?.id && user_id && serviceRequestPayments && serviceRequestPayments[serviceRequest.id]) {
            const payments = Array.isArray(serviceRequestPayments?.[serviceRequest.id])
                ? serviceRequestPayments[serviceRequest.id].filter(
                    (p) => p?.milestone_id === selectedMilestones
                )
                : [];

            if (payments && payments.length > 0) {
                payments.forEach((payment) => {
                    if (payment.ticket_agent_role === ticket_agent_role && [TransactionStatus.SUCCESS, TransactionStatus.PENDING].includes(payment.status) && payment.purpose === TransactionPurpose.TICKET_ADDITIONAL) {
                        amount += getAmount(payment);
                    }

                    const isWithdrawToBank =
                        payment.purpose === TransactionPurpose.WITHDRAW &&
                        payment.category === TransactionCategory.WALLET_TO_BANK &&
                        payment.transfer_type === TransactionTransferType.WALLET_TO_BANK;

                    if (payment.ticket_agent_role === ticket_agent_role && [TransactionPurpose.TRANSFER, TransactionPurpose.WITHDRAW].includes(payment.purpose) && payment.status === TransactionStatus.SUCCESS && !isWithdrawToBank) {
                        amount -= getAmount(payment);
                    }
                })
            };
        }
        return amount;
    }, [serviceRequestPayments, serviceRequest?.id, user_id, ticket_agent_role, selectedMilestones]);

    const memoizedMilestones = useMemo(() => {
        let m = [];
        if (serviceRequest?.milestones?.length > 0) {
            m = serviceRequest?.milestones.filter((milestone) => milestone.milestone_status !== MilestoneSubStatus.HARD_CLOSED);

            // When SP is selected, filter out other SPs' milestones - only show milestones belonging to this SP
            if (ticket_agent_role === TicketAgentRole.SP && selectedUserData) {
                const allowedMilestoneIds = selectedUserData.milestone_ids?.length > 0
                    ? selectedUserData.milestone_ids
                    : selectedUserData.milestone_id
                        ? [selectedUserData.milestone_id]
                        : [];
                if (allowedMilestoneIds.length > 0) {
                    m = m.filter((milestone) => allowedMilestoneIds.includes(milestone.id));
                }
            }
        }
        return m;
    }, [serviceRequest, ticket_agent_role, selectedUserData]);

    const hasBankDetailsFilled =
        currentBank &&
        currentAccNum &&
        currentIfsc &&
        currentHolderName;

    const hasUpiFilled = watch('upi_vpa');

    const isSubmitDisabled = showAddBankForm
        ? (addFormType === 'upi' ? !hasUpiFilled : !hasBankDetailsFilled)
        : hasBankDetails
            ? (!currentAmount || amountError)
            : false;

    if (isUserDetailsByIdLoading) return <SkeltonCardOne />

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col flex-auto min-h-0"
        >
            <div className='px-4 shrink-0'>
                <RenderMilestones milestones={memoizedMilestones} selectedMilestones={selectedMilestones} setSelectedMilestones={setSelectedMilestones} agents={serviceRequest?.agents} />
            </div>
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-3 border-b border-gray-100 shrink-0">
                {/* <h2 className="text-lg font-semibold text-gray-800 mb-2">Withdraw Amount</h2> */}
                <motion.div
                    className="flex flex-wrap gap-2"
                    initial={{ y: -10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.1 }}
                >
                    <motion.div
                        className="bg-white py-1 text-font11 px-3 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 border border-blue-100"
                        whileHover={{ scale: 1.02 }}
                    >
                        <span className="font-medium text-gray-700">Amount:</span>
                        <span className="text-blue-600 font-semibold ml-1">₹ {memoizedUserTotalWithdrawl}</span>
                    </motion.div>
                    <motion.div
                        className="bg-white py-1 text-font11 px-3 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 border border-blue-100"
                        whileHover={{ scale: 1.02 }}
                    >
                        <span className="font-medium text-gray-700">User Ticket Balance:</span>
                        <span className="text-blue-600 font-semibold ml-1">₹ {userTicketBalance}</span>
                    </motion.div>
                    <ScogoAmountBalance />
                    {/* <motion.div
                        className="bg-white py-1 text-font11 px-3 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 border border-blue-100"
                        whileHover={{ scale: 1.02 }}
                    >
                        <span className="font-medium text-gray-700">Scogo Balance:</span>
                        <span className="text-blue-600 font-semibold ml-1">₹ {myWalletDetail?.total_withdrawn ? convertToLakhOrCrore(convertIntoRupee(myWalletDetail.total_withdrawn)) : 0}</span>
                    </motion.div> */}
                </motion.div>
            </div>
            <Form
                methods={methods}
                onSubmit={handleFormSubmit}
                className="flex flex-col flex-auto min-h-0"
                submitButtonText={showAddBankForm ? (addFormType === 'upi' ? 'Add UPI' : 'Add Bank Account') : hasBankDetails ? 'Withdraw' : 'Add Bank Account'}
                onCancel={() => dispatch(closeModalAction())}
                showSubmit
                submitContainerClassName="flex gap-2 justify-end py-3 px-4 bg-gray-50 border-t border-gray-100 shrink-0"
                isLoading={formButtonLoading[formName]}
                isSubmitDisabled={isSubmitDisabled}
                submitButtonClassName="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded-md transition-colors duration-200 text-sm"
                cancelButtonClassName="border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 px-3 py-1.5 rounded-md transition-colors duration-200 text-sm"
            >
                <div className="flex-auto min-h-0 overflow-y-auto">
                    <div className='px-4 py-2'>
                        <RenderBankDetails bankDetails={memoizedUserBankDetails} />
                    </div>
                    <motion.div
                        className="px-4 pb-4 relative"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                    >
                        {(!hasAccountNumber && !hasUpiId) && !showAddBankForm ? (
                            <motion.div
                                className="flex flex-col items-center justify-center py-6 gap-3"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                            >
                                <span className="material-icons text-blue-500 text-4xl">account_balance</span>
                                <p className="text-font14 font-medium text-gray-700">Add a payment method to start the withdrawal</p>
                                <div className="flex gap-3">
                                    <button
                                        type="button"
                                        onClick={() => { setAddFormType('bank'); setShowAddBankForm(true); }}
                                        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md transition-colors duration-200 text-sm flex items-center"
                                    >
                                        <span className="material-icons text-font16 mr-1">add</span>
                                        Add Bank Account
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => { setAddFormType('upi'); setShowAddBankForm(true); }}
                                        className="border border-blue-600 text-blue-600 hover:bg-blue-50 px-4 py-2 rounded-md transition-colors duration-200 text-sm flex items-center"
                                    >
                                        <span className="material-icons text-font16 mr-1">add</span>
                                        Add UPI
                                    </button>
                                </div>
                            </motion.div>
                        ) : showAddBankForm ? (
                            <div>
                                {hasBankDetails && (
                                    <button
                                        type="button"
                                        onClick={() => setShowAddBankForm(false)}
                                        className="flex items-center text-blue-600 hover:text-blue-700 text-sm font-medium mb-4 transition-colors duration-200"
                                    >
                                        <span className="material-icons text-font18 mr-1">arrow_back</span>
                                        Back
                                    </button>
                                )}
                                {addFormType === 'upi' ? (
                                    <div className="grid grid-cols-1 gap-4">
                                        <Input
                                            label="UPI ID"
                                            name="upi_vpa"
                                            placeholder="Enter UPI ID"
                                            required
                                            className="w-full"
                                        />
                                    </div>
                                ) : (
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <Input
                                            label="Bank Name"
                                            name="bank"
                                            placeholder="Enter bank name"
                                            required={methods.watch('bank') || methods.watch('acc_num') || methods.watch('ifsc') || methods.watch('holder_name')}
                                            className="w-full"
                                        />
                                        <Input
                                            label="Account Number"
                                            name="acc_num"
                                            placeholder="Enter account number"
                                            required={methods.watch('bank') || methods.watch('acc_num') || methods.watch('ifsc') || methods.watch('holder_name')}
                                            className="w-full"
                                        />
                                        <Input
                                            label="IFSC Code"
                                            name="ifsc"
                                            placeholder="Enter IFSC code"
                                            required={methods.watch('bank') || methods.watch('acc_num') || methods.watch('ifsc') || methods.watch('holder_name')}
                                            className="w-full"
                                        />
                                        <Input
                                            label="Account Holder Name"
                                            name="holder_name"
                                            placeholder="Enter account holder name"
                                            required={methods.watch('bank') || methods.watch('acc_num') || methods.watch('ifsc') || methods.watch('holder_name')}
                                            validate={validateHolderName}
                                            className="w-full"
                                        />
                                        {!hasUpiId && (
                                            <Input
                                                label="UPI ID (Optional)"
                                                name="upi_vpa"
                                                placeholder="Enter UPI ID"
                                                className="w-full"
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className='flex gap-4'>
                                <div className="mb-6">
                                    <label className="text-gray-800 font-semibold mb-3 block text-sm whitespace-nowrap">Choose Payment Method</label>
                                    <div className="flex gap-6 mt-2">
                                        {hasAccountNumber && (
                                            <label className="flex items-center cursor-pointer bg-white hover:bg-blue-50 transition-colors duration-200 px-4 py-2 rounded-lg border-2 border-blue-100">
                                                <input
                                                    onChange={() => setPaymentMethod('account_number')}
                                                    checked={paymentMethod === 'account_number'}
                                                    type="radio"
                                                    name="payment_method"
                                                    value="account_number"
                                                    className="mr-3 h-4 w-4 text-blue-600 focus:ring-blue-500"
                                                />
                                                <span className="text-sm font-medium text-gray-700 flex items-center">
                                                    <span className="material-icons text-blue-600 mr-2 text-lg">account_balance</span>
                                                    IMPS
                                                </span>
                                            </label>
                                        )}
                                        {hasUpiId && (
                                            <label className="flex items-center cursor-pointer bg-white hover:bg-blue-50 transition-colors duration-200 px-4 py-2 rounded-lg border-2 border-blue-100">
                                                <input
                                                    onChange={() => setPaymentMethod('upi')}
                                                    checked={paymentMethod === 'upi'}
                                                    type="radio"
                                                    name="payment_method"
                                                    value="upi"
                                                    className="mr-3 h-4 w-4 text-blue-600 focus:ring-blue-500"
                                                />
                                                <span className="text-sm font-medium text-gray-700 flex items-center">
                                                    <span className="material-icons text-blue-600 mr-2 text-lg">smartphone</span>
                                                    UPI
                                                </span>
                                            </label>
                                        )}
                                    </div>
                                    {(!hasAccountNumber || !hasUpiId) && (
                                        <div className="mt-3 flex flex-col gap-2 items-start">
                                            {!hasAccountNumber && (
                                                <button
                                                    type="button"
                                                    onClick={() => { setAddFormType('bank'); setShowAddBankForm(true); }}
                                                    className="flex items-center text-blue-600 hover:text-blue-700 text-sm font-medium transition-colors duration-200"
                                                >
                                                    <span className="material-icons text-font16 mr-1">add</span>
                                                    Add Bank Account
                                                </button>
                                            )}
                                            {!hasUpiId && (
                                                <button
                                                    type="button"
                                                    onClick={() => { setAddFormType('upi'); setShowAddBankForm(true); }}
                                                    className="flex items-center text-blue-600 hover:text-blue-700 text-sm font-medium transition-colors duration-200"
                                                >
                                                    <span className="material-icons text-font16 mr-1">add</span>
                                                    Add UPI
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="mb-3">
                                    <Input
                                        allowFloats
                                        className="w-full"
                                        label="Enter Amount"
                                        type={"number"}
                                        name="amount"
                                        placeholder={"₹ 0.00"}
                                        required
                                        onChange={() => setAmountError('')}
                                        inputClassName="border-2 border-gray-200 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 rounded-lg text-lg py-3 px-4"
                                        labelClassName="text-gray-800 font-semibold mb-2 block text-sm"
                                        validate={(value) => {
                                            if (value === '' || serviceRequest.helpdesk_id !== ScogoID) return true;
                                            return (value > 0 && value <= userTicketBalance && value >= 400) ? true : "The amount should be between 400 and the user's maximum allowed limit.";
                                        }}
                                    />
                                </div>

                                {amountError && (
                                    <motion.p
                                        className="text-red-500 text-font11 -mt-2 mb-3"
                                        initial={{ opacity: 0, x: -10 }}
                                        animate={{ opacity: 1, x: 0 }}
                                    >
                                        {amountError}
                                    </motion.p>
                                )}

                                <Input
                                    label="Remarks"
                                    name="remarks"
                                    placeholder="Enter remarks"
                                    className="w-full"
                                    required
                                />
                            </div>
                        )}
                        {isShowDailyLimit && hasBankDetails && (
                            <motion.div
                                className="flex items-center text-slate-700 text-font11 mt-2 bg-yellow-50 p-1.5 rounded-md border border-yellow-100"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.4 }}
                            >
                                <span className="material-icons text-yellow-500 text-font12 mr-1">info</span>
                                <p>Your daily withdrawal limit is <span className="font-semibold">₹ {myWalletDetail?.withdraw_limit}</span></p>
                            </motion.div>
                        )}
                    </motion.div>
                </div>
            </Form>
        </motion.div>
    );
};





export const bank = 'bank';
export const upi = 'upi';


export const bankDetailPayload = ({ userId, role, type, isPo, vendorId }) => {
    const payload = { id: userId };

    if (isFe(role, type) || isCluster(role, type) || isSuperVisor(role, type) || isScm(role, type)) {
        payload.check_user = false
    }
    const isUserSpPspSpisp = (isSp(role, type) || isPsp(role, type) || isSpIsp(role, type));
    const isUserIsIsp = isIsp(role, type);
    if (isUserSpPspSpisp || isUserIsIsp) {
        payload.type = 'SP'
    }

    if (isPo) {
        payload.type = 'ISP';
        payload.id = vendorId;
    }

    return payload;
}
